function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.75 10.3L12.5 13.625L17.25 10.3",
  stroke: "#020810",
  strokeWidth: 1.39286,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3 17.9V8.4C3 7.89609 3.20018 7.41282 3.5565 7.0565C3.91282 6.70018 4.39609 6.5 4.9 6.5H20.1C20.6039 6.5 21.0872 6.70018 21.4435 7.0565C21.7998 7.41282 22 7.89609 22 8.4V17.9C22 18.4039 21.7998 18.8872 21.4435 19.2435C21.0872 19.5998 20.6039 19.8 20.1 19.8H4.9C4.39609 19.8 3.91282 19.5998 3.5565 19.2435C3.20018 18.8872 3 18.4039 3 17.9Z",
  stroke: "#020810",
  strokeWidth: 1.39286
});

var SvgMessageIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMessageIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/message-icon.74a75857.svg";
export { ForwardRef as ReactComponent };